import buttons from './buttons';
import menus from './menus';

export default (store) => {
  buttons(store);
  menus(store);
};
